// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationPageNotAnonymousWarning = require("./ConversationPageNotAnonymousWarning.bs.js");
var ConversationPageConversationMessages = require("./ConversationPageConversationMessages.bs.js");
var Conversation__ConversationsSection__ReplyInput = require("../conversationsSection/Conversation__ConversationsSection__ReplyInput.bs.js");
var ConversationPageConversation_conversation_graphql = require("../../../__generated__/ConversationPageConversation_conversation_graphql.bs.js");
var ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");

var convertFragment = ConversationPageConversation_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageConversation_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment_conversationVisibilityV5_decode = ConversationPageConversation_conversation_graphql.Utils.conversationVisibilityV5_decode;

var ConversationFragment_conversationVisibilityV5_fromString = ConversationPageConversation_conversation_graphql.Utils.conversationVisibilityV5_fromString;

var ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageConversation(props) {
  var conversation = use(props.conversation);
  var match = conversation.conversationContext;
  var match$1 = conversation.visibility;
  var tmp;
  tmp = match$1 !== undefined && (match$1 === "PRIVATE" || match$1 === "PUBLIC") && match$1 !== "PRIVATE" ? true : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationPageConversationMessages.make, {
                            conversation: conversation.fragmentRefs
                          })
                    }),
                match !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ConversationPageNotAnonymousWarning.make, {
                              conversationContext: match.fragmentRefs
                            }),
                        className: "mt-4 mb-8 p-4"
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Conversation__ConversationsSection__ReplyInput.make, {
                            focusOnMount: false,
                            conversation: conversation.fragmentRefs,
                            withAvatar: false,
                            showVisibilityInfo: tmp,
                            targetConversationMessagesConnectionId: ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversation.__id)
                          })
                    })
              ]
            });
}

var ReplyInput;

var make = ConversationPageConversation;

exports.ReplyInput = ReplyInput;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
